import React from "react";
import {
  Box,
  Flex,
  IconButton,
  Spacer,
  useBreakpointValue,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { ToggleColorModeButton } from "../../theme/ToggleColorModeButton";
import { FaUser } from "react-icons/fa";
import { Link as RouterLink, useLocation } from "react-router-dom";

const Header = () => {
  const sidebarWidth = useBreakpointValue({ base: "0", md: "250px" });
  const headerPadding = useBreakpointValue({ base: 2, md: 4 });
  const { colorMode } = useColorMode();
  const location = useLocation();

  const selectedItemBg = useColorModeValue("gray.200", "gray.700");
  const borderBottomHeaderColor = useColorModeValue("gray.300", "gray.600");

  return (
    <Flex
      as="header"
      position="fixed"
      right="0"
      top="0"
      left={sidebarWidth}
      bg={colorMode === "light" ? "white" : "gray.800"}
      backdropFilter="saturate(180%) blur(5px)"
      px={headerPadding}
      py={2}
      align="center"
      boxShadow={"sm"}
      w={`calc(100% - ${sidebarWidth})`}
      height="4rem"
      borderBottomColor={borderBottomHeaderColor}
      borderBottomWidth="1px"
    >
      <Spacer />
      {/* Profile Link */}
      <IconButton
        isRound
        as={RouterLink}
        to="/profile"
        icon={<FaUser />}
        variant="ghost"
        aria-label="Profile"
        size={{ base: "sm", md: "md" }}
        m={{ base: 1, md: 2 }}
        bg={location.pathname === "/profile" ? selectedItemBg : "transparent"}
        _hover={{
          bg: selectedItemBg,
        }}
      />
      <Box>
        <ToggleColorModeButton 
          position="relative" 
          top={{ base: "2", md: "5" }} 
          right={{ base: "2", md: "5" }}
          size={{ base: "sm", md: "md" }}
        />
      </Box>
    </Flex>
  );
};

export default Header;
